<template lang="pug">
div(:style="'min-height:' + h")
  .px-0.white.detail-head
    el-row.pl-5
      el-col(:span="8")
        Breadcrumb
      el-col.pt-5.text-right(:span="15")
        el-button(
          v-if="user.role == 3 ? true : ops.indexOf('add') > -1",
          type="primary",
          size="mini",
          :loading="loading",
          @click="goto('/purchase/purchase_demand_detail')"
        ) 新增
        el-button(
          v-if="user.role == 3 ? true : ops.indexOf('back') > -1",
          v-show="activeName == 'first'|| activeName == 'second'",
          type="danger",
          size="mini",
          :loading="loading",
          @click="back"
        ) 删除
        el-button(
          v-if="user.role == 3 ? true : ops.indexOf('place_an_order') > -1",
          v-show="activeName == 'first'",
          type="primary",
          size="mini",
          @click="gotoPlaceOrder(true)",
          :loading="loading"
        ) 下单
        el-button(
          v-if="user.role == 3 ? true : ops.indexOf('publishing_business_opportunities') > -1",
          v-show="activeName == 'first'|| activeName == 'second'",
          type="primary",
          size="mini",
          @click="setPubState(1)",
          :loading="loading"
        ) 发布商机
        el-button(
          v-if="user.role == 3 ? true : ops.indexOf('cancel_business_opportunity') > -1",
          v-show="activeName == 'four'",
          type="primary",
          size="mini",
          @click="setPubState(0)",
          :loading="loading"
        ) 取消商机
        el-button(
          v-if="user.role == 3 ? true : ops.indexOf('change_of_purchasing_organization') > -1",
          v-show="activeName == 'first'|| activeName == 'second'",
          type="primary",
          size="mini",
          @click="setSourceBuyOrg",
          :loading="loading"
        ) 变更采购组织
        el-button(
          v-if="user.role == 3 ? true : ops.indexOf('transfer_buyer') > -1",
          v-show="activeName == 'first'|| activeName == 'second'",
          type="primary",
          size="mini",
          @click="setSourceBuyPerson",
          :loading="loading"
        ) 转派采购员
        el-button(
          v-if="user.role == 3 ? true : ops.indexOf('export') > -1",
          type="primary",
          size="mini",
          :loading="loading",
          @click="exportData"
        ) 导出
        el-button(
          v-if="user.role == 3 ? true : ops.indexOf('initiate_project') > -1",
          v-show="activeName == 'first'|| activeName == 'second'",
          type="success",
          size="mini",
          @click="bid",
          :loading="loading"
        ) 发起立项
        el-button(
          v-if="user.role == 3 ? true : ops.indexOf('export') > -1",
          type="danger",
          size="mini",
          :loading="loading",
          @click="download(url + '/serverdata/file/%E9%87%87%E8%B4%AD%E9%9C%80%E6%B1%82%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xls')"
        ) 导入模版下载
        el-upload.fr.pl-2(
          :action="path",
          :before-upload="beforeUpload",
          :on-success="handleSuccess",
          :show-file-list="false",
          :headers="http_header"
        )
          el-button(size="mini", type="danger", :loading="loading") 导入
    el-tabs.title(v-model="activeName", @tab-click="handleTabClick")
      el-tab-pane(:label="'合同内需求(' + count1 + ')'", name="first")
      el-tab-pane(:label="'未匹配合同(' + count2 + ')'", name="second")
      el-tab-pane(:label="'匹配闲置物资(' + count3 + ')'", name="three")
      el-tab-pane(:label="'已发布商机(' + count4 + ')'", name="four")
      el-tab-pane(:label="'全部需求(' + count5 + ')'", name="five")
  div(style="height: 110px")
  el-main.white.pa-3.ma-4
    el-row.py-3(v-if="!flag", type="flex", justify="center")
      el-col(:span="13")
        el-row(type="flex", justify="center", :gutter="10")
          el-col(:span="13")
            el-input.w-100(
              v-model="list.key_name",
              placeholder="请输入物料名称/物料编码",
              clearable
            )
          el-col(:span="11")
            el-button(type="primary", @click="search(1)", :loading="loading") 查询
            el-button(type="text", @click="flag = true", :loading="loading") 高级搜索
    div(v-else)
      el-row.py-3(type="flex", justify="center")
        el-col(:span="22")
          el-row(type="flex", justify="center", :gutter="10")
            el-col(:span="6")
              el-input.w-100(
                v-model="list.name_material",
                placeholder="物料名称",
                clearable
              )
            el-col(:span="6")
              el-input.w-100(
                v-model="list.code_material",
                placeholder="物料编码",
                clearable
              )
            el-col(:span="6")
              el-input.w-100(
                v-model="list.source_code",
                placeholder="来源单号",
                clearable
              )
            el-col(:span="6")
              el-select.w-100(
                v-model="list.source_stock_org",
                :filter-method="sourcestockorg",
                filterable,
                placeholder="需求组织",
                clearable
              )
                el-option(
                  v-for="item in stockorg",
                  :key="item.pk_org",
                  :label="item.name",
                  :value="item.pk_org"
                )
      el-row.py-3(type="flex", justify="center")
        el-col(:span="22")
          el-row(type="flex", justify="center", :gutter="10")
            el-col(:span="6")
              el-date-picker.w-100(
                v-model="list.assign_date",
                value-format="yyyy-MM-dd",
                type="date",
                placeholder="变更时间",
                clearable
              )
            el-col(:span="6")
              el-date-picker.w-100(
                v-model="list.create_date",
                value-format="yyyy-MM-dd",
                type="date",
                placeholder="创建时间",
                clearable
              )
            el-col(:span="6")
              el-cascader.w-100(
                v-model="classify",
                placeholder="物料分类",
                clearable,
                :options="material_class.children",
                :props="{ multiple: true, label: 'text', value: 'id', checkStrictly: true }",
                filterable
              )
                template(slot-scope="{ node, data }")
                  span {{ data.code + data.text }}
            el-col(:span="6")
              el-input.w-100(
                v-model="list.code",
                placeholder="需求单号",
                clearable
              )
      el-row.py-3(type="flex", justify="center")
        el-col(:span="22")
          el-row(type="flex", justify="center", :gutter="10")
            el-col(:span="6")
              el-select.w-100(
                v-model="list.is_urgent",
                filterable,
                placeholder="是否紧急",
                clearable
              )
                el-option(label="是", value="Y")
                el-option(label="否", value="N")
            el-col(:span="6")
            el-col(:span="6")
            el-col(:span="6")
      el-row.py-1(type="flex", justify="center")
        el-col(:span="12")
          el-row(type="flex", justify="center")
            el-col(:span="10")
              el-button(type="primary", @click="search(2)", :loading="loading") 查询
              el-button(@click="clear") 清空
              el-button(type="text", @click="flag = false", :loading="loading") 收起
    el-table(
      :data="data",
      height="460",
      v-loading="loading",
      row-key="id",
      size="mini",
      @selection-change="handleSelectionChange",
      tooltip-effect="dark"
    )
      el-table-column(
        type="selection",
        fixed="left",
        width="50",
        key="selection"
      )
      el-table-column(
        prop="code_material",
        label="物料编码",
        width="120",
        key="code_material"
      )
      el-table-column(
        prop="name_material",
        label="物料名称",
        width="220",
        key="name_material",
        show-overflow-tooltip
      )
      el-table-column(prop="code", label="需求单号", width="140", key="code")
      el-table-column(
        prop="source_code",
        label="来源单号",
        width="140",
        key="source_code"
      )
      el-table-column(
        prop="name_is_urgent",
        label="紧急",
        width="60",
        key="name_is_urgent"
      )
      el-table-column(
        prop="source_num",
        label="数量",
        width="100",
        key="source_num",
        show-overflow-tooltip
      )
      el-table-column(
        prop="unit_material",
        label="单位",
        width="70",
        key="unit_material",
        show-overflow-tooltip
      )
      el-table-column(
        v-if="activeName == 'five'",
        prop="num",
        label="已执行数量",
        width="100",
        key="num",
        show-overflow-tooltip
      )
      el-table-column(
        prop="name_stock_org",
        label="需求组织",
        width="160",
        key="name_stock_org",
        show-overflow-tooltip
      )
      el-table-column(
        prop="remark_stock_person",
        label="请购人",
        width="90",
        key="remark_stock_person",
        show-overflow-tooltip
      )
      el-table-column(
        prop="source_phone",
        label="请购人手机号",
        width="120",
        key="source_phone",
        show-overflow-tooltip
      )
      el-table-column(
        prop="remark",
        label="备注",
        width="150",
        key="remark",
        show-overflow-tooltip
      )
      el-table-column(
        prop="name_buy_org",
        label="采购组织",
        width="160",
        key="name_buy_org",
        show-overflow-tooltip
      )
      el-table-column(
        prop="name_buy_person",
        label="采购员",
        width="60",
        key="name_buy_person",
        show-overflow-tooltip
      )
      el-table-column(
        prop="name_order_type",
        label="采购类型",
        width="100",
        key="name_order_type"
      )
      el-table-column(
        prop="source_date",
        label="需求时间",
        width="120",
        key="source_date",
        show-overflow-tooltip
      )
      el-table-column(
        prop="name_assigner",
        label="转派人",
        width="80",
        key="name_assigner",
        show-overflow-tooltip
      )
      el-table-column(
        prop="assign_date",
        label="接收时间",
        width="120",
        key="assign_date",
        show-overflow-tooltip
      )
      el-table-column(
        prop="create_date",
        label="创建时间",
        width="120",
        key="create_date",
        show-overflow-tooltip
      )
      el-table-column(
        prop="name_is_sync",
        label="需求来源",
        width="70",
        key="name_is_sync"
      )
      el-table-column(
        v-if="activeName == 'first' || activeName == 'second' || activeName == 'three'",
        label="操作",
        width="160",
        key="op"
      )
        template(slot-scope="scope")
          el-button(
            v-if="user.role == 3 ? true : ops.indexOf('del') > -1",
            v-show="activeName == 'first' || activeName == 'second'",
            size="mini",
            type="primary",
            plain,
            @click="getMaterialPic(scope.row.code_material)"
          ) 图片
          el-button(
            v-if="user.role == 3 ? true : ops.indexOf('del') > -1",
            v-show="scope.row.is_sync==0 && (activeName == 'first' || activeName == 'second')",
            size="mini",
            type="danger",
            plain,
            @click="del(scope.row.id)"
          ) 删除
          el-button(
            v-if="user.role == 3 ? true : ops.indexOf('details') > -1",
            v-show="activeName=='three'",
            size="mini",
            type="primary",
            plain,
            @click="goto('/purchase/idle_materials_detail/' + scope.row.id + '/3')"
          ) 详情
    el-pagination.my-4.text-center(
      @size-change="handleSizeChange",
      @current-change="handleCurrentChange",
      :current-page="list.page_num",
      :page-sizes="page_sizes",
      :page-size="list.page_size",
      layout="total,sizes, prev, pager, next, jumper",
      :total="count",
      background
    )
  el-dialog.dialog(
    title="变更采购组织",
    :visible.sync="dialogFormBuyOrg",
    width="380px",
    :show-close="false",
    :destroy-on-close="true",
    :append-to-body="true",
    :close-on-press-escape="false",
    :close-on-click-modal="true"
  )
    el-form(:model="formBuyOrg", ref="formBuyOrg", size="mini", :rules="rules")
      el-form-item(prop="pk_org")
        el-select.w-100(
          v-model="formBuyOrg.pk_org",
          filterable,
          placeholder="请选择公司"
        )
          el-option(
            v-for="item in purchase_org",
            :key="item.pk_org",
            :label="item.name",
            :value="item.pk_org"
          )
    .dialog-footer(slot="footer")
      el-button(
        size="mini",
        @click="dialogFormBuyOrg = false",
        :loading="loading"
      ) 取 消
      el-button(
        size="mini",
        type="primary",
        @click="submitFormBuyOrg",
        :loading="loading"
      ) 确 定
  el-dialog.dialog(
    title="转派采购员",
    :visible.sync="dialogFormBuyPerson",
    width="380px",
    :show-close="false",
    :destroy-on-close="true",
    :append-to-body="true",
    :close-on-press-escape="false",
    :close-on-click-modal="true"
  )
    el-form(
      :model="formBuyPerson",
      ref="formBuyPerson",
      size="mini",
      :rules="rules"
    )
      el-form-item(prop="pk_psndoc")
        el-select.w-100(
          v-model="formBuyPerson.pk_psndoc",
          :loading="loadingPerson",
          filterable,
          remote,
          placeholder="请选择人员",
          :remote-method="getPersonList"
        )
          el-option(
            v-for="(item, i) in person",
            :key="i",
            :label="item.name + '-' + item.name_org",
            :value="item.pk_psndoc"
          )
    .dialog-footer(slot="footer")
      el-button(
        size="mini",
        @click="dialogFormBuyPerson = false",
        :loading="loading"
      ) 取 消
      el-button(
        size="mini",
        type="primary",
        @click="submitFormBuyPerson",
        :loading="loading"
      ) 确 定
  el-dialog.dialog(
    title="退回操作",
    :visible.sync="dialogFormBack",
    width="380px",
    :show-close="false",
    :destroy-on-close="true",
    :append-to-body="true",
    :close-on-press-escape="false",
    :close-on-click-modal="true"
  )
    el-form(:model="formBack", ref="formBack", size="mini", :rules="rules")
      el-form-item(label="内容", prop="reason")
        el-input(
          v-model="formBack.reason",
          type="textarea",
          :autosize="{ minRows: 2, maxRows: 4 }"
        )
    .dialog-footer(slot="footer")
      el-button(
        size="mini",
        @click="dialogFormBack = false",
        :loading="loading"
      ) 取 消
      el-button(
        size="mini",
        type="primary",
        @click="submitFormBack",
        :loading="loading"
      ) 确 定
  el-dialog.dialog(
    title="物料图片",
    :visible.sync="dialogPic",
    width="50%",
    :append-to-body="true",
    :close-on-press-escape="false"
  )
    el-carousel.mb-5(
      :interval="0",
      :arrow="pics.length > 1 ? 'always' : 'never'"
    )
      el-carousel-item(v-for="(item, i) in pics", :key="i")
        el-image.w-100.h-100(fit="fill", :src="item.URL ? item.URL : ''")
  el-dialog.dialog(
    title="立项信息",
    :visible.sync="dialogFormBid",
    width="380px",
    :show-close="false",
    :destroy-on-close="true",
    :append-to-body="true",
    :close-on-press-escape="false",
    :close-on-click-modal="true"
  )
    el-form(:model="formBid", ref="formBid", size="mini", :rules="rules")
      el-form-item(label="科目类别", prop="bid_type")
        el-select.w-100(
          v-model="formBid.bid_type",
          filterable,
          placeholder="科目类别",
          @change="changeBid($event)"
        )
          el-option(
            v-for="item in bid_type",
            :key="item.code",
            :label="item.name",
            :value="item.code"
          )
      el-form-item(label="类型", prop="bidType")
        el-select.w-100(
          v-model="formBid.bidType",
          filterable,
          placeholder="类型"
        )
          el-option(label="公开", :value="1")
          el-option(label="邀请", :value="2")
      el-form-item(label="名称", prop="itemName")
        el-input(v-model="formBid.itemName", placeholder="名称")
      el-form-item(
        v-if="formBid.bid_type == 'MY50'",
        label="报名截止时间:",
        prop="offerEndtime"
      )
        el-date-picker.w-100(
          v-model="formBid.offerEndtime",
          value-format="yyyy-MM-dd HH:mm:ss",
          type="datetime",
          placeholder="报名截止时间"
        )
      el-form-item(
        v-if="formBid.bid_type == 'MY50'",
        label="开标时间:",
        prop="openTime"
      )
        el-date-picker.w-100(
          v-model="formBid.openTime",
          value-format="yyyy-MM-dd HH:mm:ss",
          type="datetime",
          placeholder="开标时间"
        )
      el-form-item(
        v-if="formBid.bid_type == 'MY40'",
        label="报名截止时间:",
        prop="signupEnddate"
      )
        el-date-picker.w-100(
          v-model="formBid.signupEnddate",
          value-format="yyyy-MM-dd HH:mm:ss",
          type="datetime",
          placeholder="报名截止时间"
        )
      el-form-item(
        v-if="formBid.bid_type == 'MY40'",
        label="报价截止时间:",
        prop="ootEnddate"
      )
        el-date-picker.w-100(
          v-model="formBid.ootEnddate",
          value-format="yyyy-MM-dd HH:mm:ss",
          type="datetime",
          placeholder="报价截止时间"
        )
      el-form-item(
        v-if="formBid.bid_type == 'MY52'",
        label="竞价开始时间:",
        prop="beginTime"
      )
        el-date-picker.w-100(
          v-model="formBid.beginTime",
          value-format="yyyy-MM-dd HH:mm:ss",
          type="datetime",
          placeholder="竞价开始时间"
        )
      el-form-item(
        v-if="formBid.bid_type == 'MY52'",
        label="竞价时长（分）",
        prop="bidDuration"
      )
        el-input(v-model="formBid.bidDuration", placeholder="竞价时长（分）")
      el-form-item(
        v-if="formBid.bid_type == 'MY52'",
        label="延时时长（秒）",
        prop="delayedTime"
      )
        el-input(v-model="formBid.delayedTime", placeholder="延时时长（秒）")
    .dialog-footer(slot="footer")
      el-button(
        size="mini",
        @click="dialogFormBid = false",
        :loading="loading"
      ) 取 消
      el-button(
        size="mini",
        type="primary",
        @click="submitFormBid",
        :loading="loading"
      ) 保 存
  el-dialog.dialog(
    title="闲置物资提示！",
    :visible.sync="dialogTableIdleGoods",
    width="700px",
    :show-close="false",
    :destroy-on-close="true",
    :append-to-body="true",
    :close-on-press-escape="false",
    :close-on-click-modal="true"
  )
    el-table(
      :data="dataIdleGoods",
      height="600",
      row-key="id",
      size="mini",
      tooltip-effect="dark"
    )
      el-table-column(prop="org", label="组织", width="250", key="org")
      el-table-column(prop="mater", label="物料", width="300", key="mater")
      el-table-column(prop="num", label="数量", width="150", key="num")
    span.dialog-footer
    el-button(@click="dialogTableIdleGoods = false") 取消操作
    el-button(type="primary", @click="gotoPlaceOrder(false)") 继续下单
</template>
<script>
import { url } from "@/utils/config";
import qs from "qs";
export default {
  data() {
    return {
      flag: false,
      url: url,
      h: "",
      loading: false,
      dialogFormVisible: false,
      dialogTableIdleGoods: false,
      rules: {
        pk_org: [{ required: true, message: "请选择公司", trigger: "change" }],
        pk_psndoc: [
          { required: true, message: "请选择采购员", trigger: "change" },
        ],
        reason: [{ required: true, message: "请填写原因", trigger: "blur" }],
        itemName: [{ required: true, message: "请输入名称", trigger: "blur" }],
        bidType: [{ required: true, message: "请选择类型", trigger: "change" }],
        bid_type: [
          { required: true, message: "请选择科目类别", trigger: "change" },
        ],
        bidDuration: [
          { pattern: /^[0-9]\d*$/, message: "只支持整数", trigger: "blur" },
        ],
        delayedTime: [
          { pattern: /^[0-9]\d*$/, message: "只支持整数", trigger: "blur" },
        ],
      },
      activeName: "first",
      disabled: false,
      list: {
        name_material: null,
        code_material: null,
        source_code: null,
        source_stock_org: null,
        assign_date: null,
        create_date: null,
        class_material: null,
        code: null,
        is_urgent: null,
        key_name: null,
        tab_num: 0,
        page_num: 1,
        page_size: 100,
      },
      classify: [],
      count: 0,
      count1: 0,
      count2: 0,
      count3: 0,
      count4: 0,
      count5: 0,
      list1: {
        tab_num: 0,
        page_num: 1,
        page_size: 100,
      },
      list2: {
        tab_num: 1,
        page_num: 1,
        page_size: 100,
      },
      list3: {
        tab_num: 2,
        page_num: 1,
        page_size: 100,
      },
      list4: {
        tab_num: 3,
        page_num: 1,
        page_size: 100,
      },
      list5: {
        tab_num: null,
        page_num: 1,
        page_size: 100,
      },
      data: [],
      dataIdleGoods: [],
      multipleSelection: [],
      dialogFormBuyOrg: false,
      formBuyOrg: {
        pk_org: "",
      },
      dialogFormBuyPerson: false,
      formBuyPerson: {
        pk_psndoc: "",
      },
      dialogFormBid: false,
      formBid: {
        bid_type: null,
        offerEndtime: "",
        openTime: "",
        signupEnddate: "",
        ootEnddate: "",
        beginTime: "",
        bidDuration: "0",
        delayedTime: "0",
      },
      person: [],
      loadingPerson: false,
      dialogFormBack: false,
      formBack: {
        id: [],
        reason: "",
      },
      pics: [],
      dialogPic: false,
      path: this.$api.purchase_demand.import_file,
      bid_type: [],
    };
  },
  methods: {
    async getMaterialPic(code) {
      this.loadingn = true;
      let res = await this.$api.global.getMaterialPic(
        qs.stringify(
          {
            code_arr: [code],
          },
          { arrayFormat: "repeat" }
        )
      );
      this.loading = false;
      if (res) {
        this.pics = res.data;
        this.dialogPic = true;
      }
    },
    beforeUpload() {
      this.loading = true;
      return true;
    },
    handleSuccess(res) {
      this.loading = false;
      if (res.code == 200) {
        this.$notify({
          message: "操作成功",
          type: "success",
        });
        this.getList();
      } else {
        this.$notify({
          message: res.msg,
          type: "error",
        });
      }
    },
    async submitFormBack() {
      this.$refs["formBack"].validate(async (valid) => {
        if (valid) {
          for (var i in this.multipleSelection) {
            this.formBack.id.push(this.multipleSelection[i].id);
          }
          this.loading = true;
          let res = await this.$api.purchase_demand.back(this.formBack);
          this.loading = false;
          if (res) {
            this.$notify({
              message: "操作成功",
              type: "success",
            });
            this.dialogFormBack = false;
            this.getList();
          }
        } else {
          return false;
        }
      });
    },
    async back() {
      if (this.multipleSelection == false) {
        this.$notify({
          message: "请选择要操作的数据",
          type: "error",
        });
        return false;
      }
      this.dialogFormBack = true;
      this.$nextTick(function () {
        this.$refs["formBack"].resetFields();
        this.formBack.id = [];
        this.formBack.reason = "";
      });
    },
    async exportData() {
      this.loading = true;
      await this.$api.purchase_demand.getBlob(this.list);
      this.loading = false;
    },
    clear() {
      this.list.name_material = null;
      this.list.code_material = null;
      this.list.source_code = null;
      this.list.source_stock_org = null;
      this.list.assign_date = null;
      this.list.create_date = null;
      this.list.class_material = null;
      this.list.code = null;
      this.list.is_urgent = null;
      this.classify = [];
    },
    del(e) {
      this.$confirm("此操作将永久删除该记录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let res = await this.$api.purchase_demand.del(e);
          if (res) {
            this.$notify({
              message: "操作成功",
              type: "success",
            });
            this.getList();
          }
        })
        .catch(() => {});
    },
    async gotoPlaceOrder(breakFlag) {
      if (this.multipleSelection == false) {
        this.$notify({
          message: "请选择要操作的数据",
          type: "error",
        });
        return false;
      }
      let mater_code_s = "";
      for (var i in this.multipleSelection) {
        mater_code_s += this.multipleSelection[i].code_material + "_";
      }
      mater_code_s = mater_code_s.substring(0, mater_code_s.length - 1);
      if (breakFlag) {
        let res = await this.$api.global.queryIdleGoods(mater_code_s);
        if (res) {
          if (res.data && res.data.length > 0) {
            this.dataIdleGoods = res.data;
            this.dialogTableIdleGoods = true;
            return false;
          }
        }
      }
      let data = [];
      for (var i in this.multipleSelection) {
        data.push(this.multipleSelection[i].id);
      }
      this.$router.push({
        path: "/purchase/place_an_order",
        query: { ids: data.toString() },
      });
    },
    async getPersonList(query) {
      if (!query) {
        return false;
      }
      this.loadingPerson = true;
      let res = await this.$api.global.personList({
        key_name: query,
        page_num: 1,
        page_size: 100,
      });
      this.loadingPerson = false;
      if (res) {
        this.person = res.data;
      }
    },
    setSourceBuyPerson() {
      if (this.multipleSelection == false) {
        this.$notify({
          message: "请选择要操作的数据",
          type: "error",
        });
        return false;
      }
      this.dialogFormBuyPerson = true;
    },
    changeBid(e) {
      this.formBid.bid_type = e;
      /*if (this.formBid.bid_type == "MY50") {
        this.formBid.offerEndtime= this.$utils.getTimeByYMD(new Date(), "YYYY-MM-DD HH:mm:ss");
        this.formBid.openTime= this.$utils.getTimeByYMD(new Date(), "YYYY-MM-DD HH:mm:ss");
      }
      if (this.formBid.bid_type == "MY40") {
        this.formBid.signupEnddate= this.$utils.getTimeByYMD(new Date(), "YYYY-MM-DD HH:mm:ss");
        this.formBid.ootEnddate= this.$utils.getTimeByYMD(new Date(), "YYYY-MM-DD HH:mm:ss");
      }
      if (this.formBid.bid_type == "MY52") {
        this.formBid.beginTime= this.$utils.getTimeByYMD(new Date(), "YYYY-MM-DD HH:mm:ss");
      }*/
    },
    bid() {
      if (this.multipleSelection == false) {
        this.$notify({
          message: "请选择要操作的数据",
          type: "error",
        });
        return false;
      }
      (this.formBid.bid_type = "MY50"), (this.dialogFormBid = true);
      this.formBid.offerEndtime = this.$utils.getTimeByYMD(
        new Date(),
        "YYYY-MM-DD HH:mm:ss"
      );
      this.formBid.openTime = this.$utils.getTimeByYMD(
        new Date(),
        "YYYY-MM-DD HH:mm:ss"
      );
      this.formBid.signupEnddate = this.$utils.getTimeByYMD(
        new Date(),
        "YYYY-MM-DD HH:mm:ss"
      );
      this.formBid.ootEnddate = this.$utils.getTimeByYMD(
        new Date(),
        "YYYY-MM-DD HH:mm:ss"
      );
      this.formBid.beginTime = this.$utils.getTimeByYMD(
        new Date(),
        "YYYY-MM-DD HH:mm:ss"
      );
    },
    submitFormBid() {
      this.$refs["formBid"].validate(async (valid) => {
        if (valid) {
          let data = [];
          for (var i in this.multipleSelection) {
            data.push(this.multipleSelection[i]);
          }
          this.loading = true;
          let res = await this.$api.purchase_demand.bid({
            list: data,
            beginTime: this.formBid.beginTime,
            bidDuration: this.formBid.bidDuration,
            bid_type: this.formBid.bid_type,
            delayedTime: this.formBid.delayedTime,
            offerEndtime: this.formBid.offerEndtime,
            ootEnddate: this.formBid.ootEnddate,
            openTime: this.formBid.openTime,
            signupEnddate: this.formBid.signupEnddate,
            itemName: this.formBid.itemName,
            bidType: this.formBid.bidType,
          });
          this.loading = false;

          //let res = await this.$api.purchase_demand.bid(this.formBid);
          if (res) {
            this.dialogFormBid = false;
            this.getList();
            this.$notify({
              message: "操作成功",
              type: "success",
            });
          }
        } else {
          return false;
        }
      });
    },
    submitFormBuyPerson() {
      this.$refs["formBuyPerson"].validate(async (valid) => {
        if (valid) {
          let data = [];
          for (var i in this.multipleSelection) {
            data.push({
              id: this.multipleSelection[i].id,
              source_buy_person: this.formBuyPerson.pk_psndoc,
            });
          }
          let res = await this.$api.purchase_demand.updateList(data);
          if (res) {
            this.dialogFormBuyPerson = false;
            this.getList();
            this.$notify({
              message: "操作成功",
              type: "success",
            });
          }
        } else {
          return false;
        }
      });
    },
    setSourceBuyOrg() {
      if (this.multipleSelection == false) {
        this.$notify({
          message: "请选择要匹配的物料",
          type: "error",
        });
        return false;
      }
      this.dialogFormBuyOrg = true;
    },
    submitFormBuyOrg() {
      this.$refs["formBuyOrg"].validate(async (valid) => {
        if (valid) {
          let data = [];
          for (var i in this.multipleSelection) {
            data.push({
              id: this.multipleSelection[i].id,
              source_buy_org: this.formBuyOrg.pk_org,
            });
          }
          let res = await this.$api.purchase_demand.updateList(data);
          if (res) {
            this.dialogFormBuyOrg = false;
            this.getList();
            this.$notify({
              message: "操作成功",
              type: "success",
            });
          }
        } else {
          return false;
        }
      });
    },
    async setPubState(type) {
      if (this.multipleSelection == false) {
        this.$notify({
          message: "请选择需要操作的数据",
          type: "error",
        });
        return false;
      }
      let data = [];
      for (var i in this.multipleSelection) {
        data.push({ id: this.multipleSelection[i].id, pub_state: type });
      }
      this.loading = true;
      let res = await this.$api.purchase_demand.updateList(data);
      this.loading = false;
      if (res) {
        this.getList();
        this.$notify({
          message: "操作成功",
          type: "success",
        });
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    search(type) {
      if (type == 2) {
        this.list.key_name = null;
      } else {
        this.list.name_material = null;
        this.list.code_material = null;
        this.list.source_code = null;
        this.list.source_stock_org = null;
        this.list.assign_date = null;
        this.list.create_date = null;
        this.list.class_material = null;
        this.list.code = null;
        this.list.is_urgent = null;
      }
      let k = [];
      for (var i in this.classify) {
        k.push(this.classify[i][this.classify[i].length - 1]);
      }
      localStorage.setItem(
        "PurchaseDemand_class",
        JSON.stringify(this.classify)
      );
      this.list.class_material = k.toString();
      this.list.page_num = 1;
      this.$router.push({
        path: this.$route.path,
        hash: this.$route.hash,
        query: this.list,
      });
    },
    handleSizeChange(e) {
      this.list.page_size = e;
      this.$router.push({
        path: this.$route.path,
        hash: this.$route.hash,
        query: this.list,
      });
    },
    handleCurrentChange(e) {
      this.list.page_num = e;
      this.$router.push({
        path: this.$route.path,
        hash: this.$route.hash,
        query: this.list,
      });
    },
    handleTabClick(tab) {
      let data = this.list;
      if (tab.name == "first") {
        data.page_size = this.list1.page_size;
        data.page_num = this.list1.page_num;
        data.tab_num = this.list1.tab_num;
      } else if (tab.name == "second") {
        data.page_size = this.list2.page_size;
        data.page_num = this.list2.page_num;
        data.tab_num = this.list2.tab_num;
      } else if (tab.name == "three") {
        data.page_size = this.list3.page_size;
        data.page_num = this.list3.page_num;
        data.tab_num = this.list3.tab_num;
      } else if (tab.name == "four") {
        data.page_size = this.list4.page_size;
        data.page_num = this.list4.page_num;
        data.tab_num = this.list4.tab_num;
      } else if (tab.name == "five") {
        data.page_size = this.list5.page_size;
        data.page_num = this.list5.page_num;
        data.tab_num = this.list5.tab_num;
      }
      this.$router.push({
        path: this.$route.path,
        hash: "#" + tab.name,
        query: data,
      });
    },
    async getList() {
      this.loading = true;
      let res = await this.$api.purchase_demand.getList(this.list);
      this.loading = false;
      if (res) {
        this.data = res.data;
        this.count1 = res.count1 ? res.count1 : 0;
        this.count2 = res.count2 ? res.count2 : 0;
        this.count3 = res.count3 ? res.count3 : 0;
        this.count4 = res.count4 ? res.count4 : 0;
        this.count5 = res.count5 ? res.count5 : 0;
        switch (this.activeName) {
          case "first":
            this.count = this.count1;
            break;
          case "second":
            this.count = this.count2;
            break;
          case "three":
            this.count = this.count3;
            break;
          case "four":
            this.count = this.count4;
            break;
          case "five":
            this.count = this.count5;
            break;
          default:
            break;
        }
      }
    },
    initList() {
      let data = this.$route.query;
      if (JSON.stringify(data) != "{}") {
        this.list = this.$utils.cloneDeep(data);
        if (data.page_num) {
          this.list.page_num = parseInt(data.page_num);
        }
        if (data.page_size) {
          this.list.page_size =
            this.page_sizes.indexOf(parseInt(data.page_size)) > -1
              ? parseInt(data.page_size)
              : this.page_sizes[0];
        }
        if (this.list.class_material && this.classify == false) {
          this.classify = JSON.parse(
            localStorage.getItem("PurchaseDemand_class")
          );
        }
        if (
          this.list.name_material ||
          this.list.code_material ||
          this.list.source_code ||
          this.list.source_stock_org ||
          this.list.assign_date ||
          this.list.create_date ||
          this.list.class_material ||
          this.list.code ||
          this.list.is_urgent
        ) {
          this.flag = true;
        }
      } else {
        this.list.tab_num = this.list1.tab_num;
      }
      let tab_num = this.list.tab_num;
      switch (parseInt(tab_num)) {
        case 0:
          this.activeName = "first";
          break;
        case 1:
          this.activeName = "second";
          break;
        case 2:
          this.activeName = "three";
          break;
        case 3:
          this.activeName = "four";
          break;
        default:
          this.list.tab_num = null;
          this.activeName = "five";
          break;
      }
      switch (this.activeName) {
        case "first":
          this.list1.page_size = this.list.page_size;
          this.list1.page_num = this.list.page_num;
          break;
        case "second":
          this.list2.page_size = this.list.page_size;
          this.list2.page_num = this.list.page_num;
          break;
        case "three":
          this.list3.page_size = this.list.page_size;
          this.list3.page_num = this.list.page_num;
          break;
        case "four":
          this.list4.page_size = this.list.page_size;
          this.list4.page_num = this.list.page_num;
          break;
        case "five":
          this.list5.page_size = this.list.page_size;
          this.list5.page_num = this.list.page_num;
          break;
        default:
          break;
      }
      this.$router.push({
        path: this.$route.path,
        hash: "#" + this.activeName,
        query: this.list,
      });
    },
    init() {
      this.activeName = this.$route.hash
        ? this.$route.hash.split("#")[1]
        : "first";
      this.initList();
      this.getList();
    },
  },
  mounted() {
    this.h = document.body.clientHeight - 61 + "px";
  },
  created() {
    if (
      this.$store.state.token &&
      JSON.stringify(this.$store.state.material_class) == "{}"
    )
      this.getMaterialClass();
    if (this.$store.state.token && this.$store.state.purchase_org == false)
      this.getPurchaseOrg();
    if (this.$store.state.token && this.$store.state.stock_org == false)
      this.getStockOrg();
    this.getDefdoc(this, { code: "bid_type" });
  },
  watch: {
    $route: {
      handler: "init",
      immediate: true,
    },
  },
};
</script>
